import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../../pipes/pipes.module';
import { ReportComponent } from './report.component';

@NgModule({
    declarations: [ReportComponent],
    imports: [CommonModule, TranslateModule, TwcModule, PipesModule],
    exports: [ReportComponent],
})
export class ReportModule {}
